import { Box, Text } from '@factorialco/deprecated-design-system'
import { DataSchemaItemFragment } from 'generated/resources/graphql'
import { camelCase } from 'lodash'

import { useCurrentAccessWeekdays } from 'modules/core/hooks/useCurrentAccessWeekdays'
import i18n from 'modules/core/lib/i18n'

interface Props {
  dataSchemaItem?: DataSchemaItemFragment
  values: string
  onChange: (fieldName: string, value: string) => void
}

const getWorkDaysLabel = (type: string) => {
  switch (type) {
    case 'friday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.friday')
    case 'monday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.monday')
    case 'saturday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.saturday')
    case 'sunday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.sunday')
    case 'thursday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.thursday')
    case 'tuesday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.tuesday')
    case 'wednesday':
      return i18n.t('shift_management.actions_sidepanel.time_period.custom_days_selector.wednesday')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}
export const DaysSelectorField = ({ dataSchemaItem, values, onChange }: Props) => {
  const weekDays = useCurrentAccessWeekdays()

  if (!dataSchemaItem) {
    return null
  }

  const select = (day: string) => {
    const selectedDays: string[] = values ? values.split(',') : []
    const index = selectedDays.findIndex((d) => d === day)

    if (index > -1) {
      selectedDays.splice(index, 1)

      onChange(
        camelCase(dataSchemaItem.fieldName),
        !selectedDays.length ? '' : selectedDays.join(',')
      )
      return
    }

    onChange(camelCase(dataSchemaItem.fieldName), selectedDays.concat([day]).join(','))
  }

  const selectedDays = values.split(',')

  return (
    <Box gap="s8">
      <Text.Normal size="200" weight="medium" color="grey1000">
        {dataSchemaItem.label}
      </Text.Normal>
      <Box flexDirection="row" gap="s4">
        {weekDays.map((day) => {
          const shortDay = getWorkDaysLabel(day ?? '')
          const isSelected = selectedDays.includes(day)

          return (
            <Box
              minWidth="s24"
              minHeight="s24"
              textAlign="center"
              background={isSelected ? 'viridian1000' : 'viridian100'}
              alignItems="center"
              justifyContent="center"
              borderRadius={{ all: 'abs004' }}
              onClick={() => select(day)}
              key={day}
            >
              <Text.Normal size="200" color={isSelected ? 'white' : 'grey800'}>
                {shortDay}
              </Text.Normal>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
